import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a88d61b755b8c0014152f4c_1788800163658_55081968/coedparc/src/app/sign-up-login-screen/components/AuthScreen.tsx");
